export default "__VITE_ASSET__DOr30KTN__"